export { default as WelcomeSlide1 } from "./WelcomeSlide1";
export { default as WelcomeSlide2 } from "./WelcomeSlide2";
export { default as WelcomeSlide3 } from "./WelcomeSlide3";
export { default as WelcomeSlide4 } from "./WelcomeSlide4";
export { default as WelcomeSlide5 } from "./WelcomeSlide5";
export { default as WelcomeSlide6 } from "./WelcomeSlide6";
export { default as WelcomeSlideNew1 } from "./WelcomeSlideNew1";
export { default as WelcomeSlideNew2 } from "./WelcomeSlideNew2";
export { default as WelcomeSlideNew3 } from "./WelcomeSlideNew3";
export { default as WelcomeSlideNew4 } from "./WelcomeSlideNew4";
